import React   from 'react';
import {useSingleTheme} from '../../../components/hooks/hooks-mongoDB/useSingleTheme';
import {useArticles} from '../../../components/hooks/hooks-mongoDB/useArticles';
import {useParagraphs} from '../../../components/hooks/hooks-mongoDB/useParagraphs';
import ThemesScreen from '../pannelli/ThemesScreen';

/*
  * Few fonctions for Province's tHemes
  * October 08st, 2025
*/
export function WineBottlesAB() {
  const {theme} = useSingleTheme('abruzzo');
  const abruzzoReg_Theme = theme;
  const {articles} = useArticles('abruzzo');
  const article = articles.slice(4, 5) || [];
  const article_Abruzzo = article[0]; 
  const {paragraphs} = useParagraphs('abruzzo_5');

  return (
    <>
      {theme && <ThemesScreen theme={abruzzoReg_Theme} article={article_Abruzzo} paragraphs={paragraphs}/>}
    </> 
  )
}

/*
  * Few fonctions for Province's tHemes
  * October 08st, 2025
*/
export function WineBottlesAQ() {
  const {theme} = useSingleTheme('aquila');
  const aquilaReg_Theme = theme;
  const {articles} = useArticles('aquila');
  const article = articles.slice(4, 5) || [];
  const article_Aquila = article[0]; 
  const {paragraphs} = useParagraphs('aquila_5'); 

  return (
    <>
      {theme && <ThemesScreen temaCtl={aquilaReg_Theme} tema={article_Aquila} paragraphs={paragraphs}/>}
    </> 
  )
}

/*
  * Few fonctions for Province's tHemes
  * October 08st, 2025
*/
export function WineBottlesCH() {
  const {theme} = useSingleTheme('chieti');
  const chietiReg_Theme = theme;
  const {articles} = useArticles('chieti');
  const article = articles.slice(4, 5) || [];
  const article_Chieti = article[0]; 
  const {paragraphs} = useParagraphs('chieti_5'); 

  return (
    <>
      {theme && <ThemesScreen temaCtl={chietiReg_Theme} tema={article_Chieti} paragraphs={paragraphs}/>}
    </> 
  )
}

/*
  * Few fonctions for Province's tHemes
  * October 08st, 2025
*/
export function WineBottlesPE() {
  const {theme} = useSingleTheme('pescara');
  const pescaraReg_Theme = theme;
  const {articles} = useArticles('pescara');
  const article = articles.slice(4, 5) || [];
  const article_Pescara = article[0]; 
  const {paragraphs} = useParagraphs('pescara_5');

  return (
    <>
      {theme && <ThemesScreen temaCtl={pescaraReg_Theme} tema={article_Pescara} paragraphs={paragraphs}/>}
    </> 
  )
}

/*
  * Few fonctions for Province's tHemes
  * October 08st, 2025
*/
export function WineBottlesTE() {
  const {theme} = useSingleTheme('teramo');
  const teramoReg_Theme = theme;
  const {articles} = useArticles('teramo');
  const article = articles.slice(4, 5) || [];
  const article_Teramo = article[0]; 
  const {paragraphs} = useParagraphs('teramo_5'); 

  return (
    <>
      {theme && <ThemesScreen temaCtl={teramoReg_Theme} tema={article_Teramo} paragraphs={paragraphs}/>}
    </> 
  )
}
